exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gvl-privacy p{margin:12px 0 15px 0}", ""]);

